import React, { useContext, useMemo } from 'react';
import { CardHeader } from '../../shared/card/card-header';
import './card-clients.scss';
import { LoaderContext } from '../../../shared/utils/loader/loader-wrapper';
import { DefaultLoadingComponent } from '../../../shared/utils/loader/default-loading-component';
export var CardClientDownloadsHeader = function () {
    var data = useContext(LoaderContext);
    var isLoading = useMemo(function () { return data.isLoading; }, [data.isLoading]);
    return (React.createElement(CardHeader, null,
        React.createElement("header", { className: "c-card__header" },
            React.createElement("div", { className: "c-card__header__top" },
                React.createElement("div", { className: "c-card__header__applicant" }, isLoading ? React.createElement(DefaultLoadingComponent, { count: 1, height: 10, width: '50%' }) : React.createElement("h3", null, "Documents"))))));
};
